import React from 'react';
import classes from './style.module.scss';

export default function Divider() {
  return <div className={classes.container} />;
}
